import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import HeroSignup from "@/components/HeroSignup";
import MobileFeedTabs from "@/components/MobileFeedTabs";
import RecommendedArtists from "@/components/RecommendedArtists";
import UpcomingConcerts from "@/components/UpcomingConcerts";
import { PersonalizedFeedProvider } from "@/hooks/usePersonalizedFeed";
import Footer from "@/components/Footer";
import SplashScreen from "@/components/SplashScreen";


const Index = () => {
  const { user } = useAuth();
  const hasSeenSplash = sessionStorage.getItem("encore_splash_seen") === "true";
  const [showSplash, setShowSplash] = useState(!hasSeenSplash);

  const handleSplashComplete = () => {
    sessionStorage.setItem("encore_splash_seen", "true");
    setShowSplash(false);
  };

  return (
    <>
      <AnimatePresence>
        {showSplash && (
          <SplashScreen onComplete={handleSplashComplete} />
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: showSplash ? 0 : 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="min-h-screen bg-background relative"
      >
        
        <Navbar />
        <main>
          {!user ? <HeroSignup /> : <div style={{ paddingTop: "var(--navbar-height, 96px)" }} />}
          <MobileFeedTabs />
          <PersonalizedFeedProvider>
            <RecommendedArtists />
            <UpcomingConcerts />
          </PersonalizedFeedProvider>
        </main>
        <Footer />
      </motion.div>
    </>
  );
};

export default Index;
